import React, { useMemo, useRef, useState } from "react";
import { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Card, GridLegacy } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import Buttonbar from "../LightspeedK/Components/Buttonbar";
import Method from "../LightspeedK/InputForms/Method";
import Overzicht from "../LightspeedK/Components/Overzicht";
import MenuSyncSettings from "../MenuSyncSettings";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import FormJson from "../../../../components/Forms/FormJson";
import TakeawayDeliverySetting from "./TakeawayDeliverySetting";

function LigthspeedK() {
  const { menukaartVestigingId, vestigingId } = useFormContext();
  const [showInputForm, setShowInputForm] = useState(false);
  const form = useRef(null);
  const {
    field: { value: extra_settings__paymentApiIdsValue, onChange: extra_settings__paymentApiIdsOnChange },
  } = useController({ name: "extra_settings__paymentApiIds" });

  const handleButtonClick = (type) => {
    form.current = getInputForm(type);
    setShowInputForm(true);
  };

  const handleCloseClick = () => {
    form.current = null;
    setShowInputForm(false);
  };

  const onDelete = (objectToDelete) => {
    extra_settings__paymentApiIdsOnChange(
      JSON.stringify(JSON.parse(extra_settings__paymentApiIdsValue).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  const getInputForm = (type, value = undefined) => {
    let form = null;
    let action = "ADD";
    if (value !== undefined) {
      action = "EDIT";
    }

    switch (type) {
      case "method":
        form = (
          <Method
            closeForm={handleCloseClick}
            methods={extra_settings__paymentApiIdsValue ? JSON.parse(extra_settings__paymentApiIdsValue) : []}
            onSave={(value) => {
              const arr = extra_settings__paymentApiIdsValue ? JSON.parse(extra_settings__paymentApiIdsValue) : [];
              if (action === "ADD") {
                arr.push(value);
              } else if (action === "EDIT") {
                arr.forEach((obj, key) => {
                  if (obj.name === value.oldName) {
                    delete value.oldName;
                    arr[key] = value;
                  }
                });
              }
              extra_settings__paymentApiIdsOnChange(JSON.stringify(arr));
            }}
            salesareaId={vestigingId}
            type={"LIGHTSPEEDK"}
            value={value}
          />
        );
        break;
    }

    return form;
  };

  const orderMode = useMemo(
    () => [
      { value: "table", label: "Op Tafel" },
      { value: "delivery", label: "Takeway/Delivery" },
    ],
    []
  );

  const orderModeOptions = useMemo(() => convertObjectToSelectOptions(orderMode), []);
  const orderModeValue = useWatch({ name: "apiaccounts__lightspeedKOrderMode" });
  const vatGroupProfileValue = useWatch({ name: "apiaccounts__lightspeedKVatGroupProfile" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>{getTranslation("Lightspeed K", "Lightspeed K")}</h3>
            </GridLegacy>
            <FormSwitchTC
              name={"apiaccounts__useTest"}
              tDefault={"Gebruik test omgeving"}
              tKey={"vestigingen.form.apiaccounts.label.useTest"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getBusinessLocations?vid=${vestigingId}` }}
              name={"apiaccounts__lightspeedKBusinessLocations"}
              tDefault={"Business location id"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKBusinessLocations"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getMenus?vid=${vestigingId}` }}
              multiple={true}
              name={"apiaccounts__lightspeedKMenus"}
              tDefault={"Sync following menus"}
              tKey={"apiaccounts__lightspeedKMenus"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormTextTC
              name={"apiaccounts__lightspeedKWebhookId"}
              tDefault={"Webhook ID"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKWebhookId"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getPaymentMethods?vid=${vestigingId}` }}
              name={"apiaccounts__lightspeedKPaymentMethod"}
              tDefault={"Payment id"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKPaymentMethod"}
            />
            <FormSwitchTC
              name={"apiaccounts__lightspeedKVatGroupProfile"}
              tDefault={"VAT / Account Profile"}
              tKey={"vestigingen.form.apiaccounts.label.lightspeedKVatGroupProfile"}
            />
            <FormSelectTC
              name={"apiaccounts__lightspeedKOrderMode"}
              options={orderModeOptions}
              tDefault={"Order mode"}
              tKey={"vestigingen.form.lightspeedk.label.orderMode"}
            />
            <TakeawayDeliverySetting disabled={orderModeValue === "table"} />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getAllAccountProfiles?vid=${vestigingId}` }}
              fieldProps={{ disabled: orderModeValue !== "table" && !vatGroupProfileValue }}
              name={"apiaccounts__lightspeedKAccountProfileCode"}
              tDefault={"Rekening profile code (Standaard)"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKAccountProfileCode"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getAllAccountProfiles?vid=${vestigingId}` }}
              fieldProps={{ disabled: orderModeValue === "table" && !vatGroupProfileValue }}
              name={"apiaccounts__lightspeedKAccountProfileCodePickup"}
              tDefault={"Rekening profile code (Ophaal)"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKAccountProfileCodePickup"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getAllAccountProfiles?vid=${vestigingId}` }}
              fieldProps={{ disabled: orderModeValue === "table" && !vatGroupProfileValue }}
              name={"apiaccounts__lightspeedKAccountProfileCodeEatIn"}
              tDefault={"Rekening profile code (Eat-In)"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKAccountProfileCodeEatIn"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getAllAccountProfiles?vid=${vestigingId}` }}
              fieldProps={{ disabled: orderModeValue === "table" || vatGroupProfileValue }}
              name={"apiaccounts__lightspeedKAccountProfileCodeDelivery"}
              tDefault={"Rekening profile code (Bezorgen)"}
              tKey={"vestigingen.form.lightspeedk.label.lightspeedKAccountProfileCodeDelivery"}
            />
            <FormSwitchTC
              name={"extra_settings__sentCourses"}
              tDefault={"Sent courses #"}
              tKey={"vestigingen.form.extra_settings.label.sentCourses"}
            />
            <FormSwitchTC
              name={"useWithoutTableOverlappingMiddleware"}
              tDefault={"Don't overlap table request"}
              tKey={"vestigingen.form.overige.label.useWithoutTableOverlappingMiddleware"}
            />
            <FormSwitchTC
              name={"splitItems"}
              tDefault={"Split items (Send all multiple order-items as single order-items to POS API)"}
              tKey={"vestigingen.form.overige.label.splitItems"}
            />
            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.pos.fiscalization"}
              tKey={"Print fiscalization data on receipt"}
            />
            <FormSwitchTC
              defaultValue={false}
              name={"custom_data.pos.send_pager_as_ordernumber"}
              tKey={"Send pagernumber as order number"}
            />
            <FormAsyncTC
              async={{ url: `core/pos-api/lightspeed-k/getDiscounts?vid=${vestigingId}` }}
              name={"custom_data.third_party_settings.lightspeedk.free_percentage_discount"}
              tDefault={"LightspeedK Free Percentage Discount"}
              tKey={"custom_data.third_party_settings.lightspeedk.free_percentage_discount"}
            />
          </GridLegacy>

          <MenuSyncSettings />

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                {getTranslation(
                  "Payment IDS for using multiple payment methods",
                  "Payment IDS for using multiple payment methods"
                )}
              </h3>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Buttonbar disableAll={showInputForm} onClick={handleButtonClick} />
            </GridLegacy>
          </GridLegacy>

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              {form.current}
            </GridLegacy>
          </GridLegacy>
          <Overzicht customFields={extra_settings__paymentApiIdsValue} disableAll={showInputForm} onDelete={onDelete} />
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>{getTranslation("JSON", "JSON")}</h3>
            </GridLegacy>
            <FormJson
              name={"extra_settings__paymentApiIds"}
              tDefault={"JSON"}
              tKey={"vestigingen.form.customfields.headers.json"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default LigthspeedK;
